import { useSelector, useDispatch } from 'react-redux';
import {
    toggleSidebar,
    setSidebarCollapsed,
    BREAKPOINTS
} from '../Store/slices/Responsive';

/**
 * Custom hook to access responsive state and actions
 * Provides a clean interface for components to interact with responsive features
 */
const useResponsive = () => {
    const dispatch = useDispatch();
    const responsiveState = useSelector((state) => state.responsive);

    return {
        // Breakpoints for consistent usage
        breakpoints: BREAKPOINTS,

        // Responsive state
        isMobile: responsiveState.isMobile,
        isTablet: responsiveState.isTablet,
        isDesktop: responsiveState.isDesktop,
        isResponsiveMode: responsiveState.isResponsiveMode,
        width: responsiveState.width,
        height: responsiveState.height,
        isSidebarCollapsed: responsiveState.isSidebarCollapsed,

        // Actions
        toggleSidebar: () => dispatch(toggleSidebar()),
        setSidebarCollapsed: (collapsed) => dispatch(setSidebarCollapsed(collapsed)),

        // Helper methods
        isBreakpoint: (breakpoint) => {
            switch (breakpoint) {
                case 'mobile':
                    return responsiveState.isMobile;
                case 'tablet':
                    return responsiveState.isTablet;
                case 'desktop':
                    return responsiveState.isDesktop;
                default:
                    return false;
            }
        }
    };
};

export default useResponsive; 